module.exports = __webpack_public_path__ + "img/franzi.62ccbc9c.jpg";